import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAnnouncement } from '@/hooks';
import { cn } from '@/utils';

const typeStyles = {
  info: 'bg-sky-50 text-sky-800 dark:bg-sky-950/50 dark:text-sky-200',
  warning: 'bg-amber-50 text-amber-800 dark:bg-amber-950/50 dark:text-amber-200',
  success: 'bg-emerald-50 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-200',
};

export function SJAnnouncementBar() {
  const { data: announcement } = useAnnouncement();
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    if (announcement) {
      const dismissed = localStorage.getItem(`sj-announcement-dismissed-${announcement.id}`);
      if (dismissed === 'true') setIsDismissed(true);
    }
  }, [announcement]);

  function handleDismiss() {
    if (announcement) {
      localStorage.setItem(`sj-announcement-dismissed-${announcement.id}`, 'true');
    }
    setIsDismissed(true);
  }

  if (!announcement || isDismissed) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: 'auto', opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        transition={{ duration: 0.2 }}
        className={cn('relative z-[101] overflow-hidden', typeStyles[announcement.type])}
      >
        <div className="mx-auto flex max-w-[1280px] items-center justify-center gap-3 px-6 py-2 text-center">
          <p className="text-xs font-medium sm:text-sm">
            {announcement.content}
            {announcement.link_url && announcement.link_text && (
              <Link
                to={announcement.link_url}
                className="ml-2 inline-flex items-center gap-1 font-semibold underline underline-offset-2"
              >
                {announcement.link_text}
                <ArrowRight className="h-3 w-3" />
              </Link>
            )}
          </p>
          <button
            onClick={handleDismiss}
            className="ml-2 shrink-0 rounded-[6px] p-1 opacity-60 transition-opacity hover:opacity-100"
            aria-label="Dismiss announcement"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
